'use client';

import { useState } from 'react';

import Text from '@/components/common/Text';
import Button from '@/components/common/Button';
import Tooltip from '@/components/common/Tooltip';
import { GradientAicon } from '@/components/common/Aicons';
import BurnIngicator from '@/components/common/BurnIngicator';
import { GoalModel, getGoalStageReasonString } from '@/types/goals';
import { formatDate } from '@/utils/date';

interface GoalListRowProps {
  goal: GoalModel;
  isSelectedGoal: boolean;
  onSelectGoal: (goal: GoalModel) => void;
}

/**
 * 目標一覧の行コンポーネント
 * @param param0
 * @returns
 */
export default function GoalListRow({ goal, isSelectedGoal, onSelectGoal }: GoalListRowProps) {
  /**
   * useState
   */
  const [isLoading] = useState(false);

  /**
   * 目標の切り替え
   */
  const handleSelectGoal = (goal: GoalModel) => {
    onSelectGoal(goal);
  };

  return (
    <>
      <li
        key={goal.id}
        className="w-full bg-cover bg-center rounded-lg bg-gray-100"
        // style={goal.activated ? { backgroundImage: "url('/images/goals.jpg')" } : undefined}
      >
        <div className="flex">
          <div className="grow p-4 whitespace-pre-line break-all">
            {goal.activated && (
              <div className="mb-1 mt-0">
                <GradientAicon>Current Goals</GradientAicon>
              </div>
            )}
            <Text className="italic">{goal.immediate_goal}</Text>
          </div>
          <div>
            <div className="flex pt-2">
              {isSelectedGoal ? (
                <div className="flex justify-center items-center text-white bg-green-500 min-w-[40px] min-h-[40px] rounded-full mr-2 pr-0 pl-0">
                  <svg
                    className="w-[18px] h-[18px]"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 11.917 9.724 16.5 19 7.5"
                    />
                  </svg>
                </div>
              ) : (
                <Button
                  className="min-w-[40px] min-h-[40px] mr-2 pr-0 pl-0"
                  type="button"
                  buttonType="outlinePrimary"
                  isLoading={isLoading}
                  onClick={() => handleSelectGoal(goal)}>
                  <svg
                    className="w-[18px] h-[18px]"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 11.917 9.724 16.5 19 7.5"
                    />
                  </svg>
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className="mt-1 p-4">
          <Tooltip content={getGoalStageReasonString(goal?.progress.reason_code) || '-'} position="bottom-right">
            <BurnIngicator stage={goal.progress.stage} />
          </Tooltip>
        </div>

        <div className="pb-4 px-4 flex items-center">
          <svg
            className="w-3 h-3 me-1 text-gray-500"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 20">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M5 5h8m-1-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1m6 0v3H6V2m6 0h4a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4m0 9.464 2.025 1.965L12 9.571"
            />
          </svg>
          <div className="font-footballlog text-gray-500 text-sm">{formatDate(goal.created_at)}</div>

          {/* {goal.max_stats_log && goal.max_stats_log.stats > 0 && (
            <>
              <svg
                className="w-3 h-3 ms-4 me-1 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 18">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M10 16.5c0-1-8-2.7-9-2V1.8c1-1 9 .707 9 1.706M10 16.5V3.506M10 16.5c0-1 8-2.7 9-2V1.8c-1-1-9 .707-9 1.706"
                />
              </svg>
              <div className="font-footballlog text-gray-500 text-sm font-semibold">Best: </div>
              <div className="font-footballlog text-gray-500 text-sm font-semibold">
                ★{goal.max_stats_log.stats}&nbsp;
              </div>
              <div className="text-gray-500 text-xs ms-1">{goal.max_stats_log.title}</div>
            </>
          )} */}
        </div>
      </li>
    </>
  );
}
